import React, { useState, useEffect, useContext } from "react";
import { Toolbar } from "primereact/toolbar";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { InputText } from "primereact/inputtext";
import { useDebounce } from 'primereact/hooks';
import { Dropdown } from "primereact/dropdown";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useNavigate, useParams } from "react-router-dom";
import { ConfirmPopup, confirmPopup } from 'primereact/confirmpopup';
import { FilterMatchMode, FilterOperator, FilterService } from 'primereact/api';
import { getPathByName } from "../../../routesUtils"
import { appContext } from '../../../App'

function Users() {
    const navigate = useNavigate();
    const [users, setUsers] = useState([]);
    const [search, debouncedSearch, setSearch] = useDebounce('', 2000);
    let { portalId } = useParams(null);
    const AppContext = useContext(appContext)
    const [filters, setFilters] = useState({
      name: { value: null, matchMode: FilterMatchMode.CONTAINS },
      email: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      enabled: { value: null, matchMode: FilterMatchMode.EQUALS },
  });

    const loadUsers = () => {
        let fields = [
            'users.id',
            'users.name',
            'users.email',
            'users.enabled'
        ]
        let params = [{key:'include',value:fields.join(',')}]
        if (search.length > 0) params.push({ key: "search", value: search });
        AppContext.api.getRecords("users", params).then((res) => {
            setUsers(res.data.records);
        });
    }

    useEffect(() => {
        loadUsers()
    }, [debouncedSearch]);

    const startContent = (
        <React.Fragment>
            <span className="p-input-icon-left">
                <i className="pi pi-search" />
                <InputText
                    value={search}
                    placeholder="Rechercher un utilisateur"
                    onChange={(e) => setSearch(e.target.value)} />
            </span>
        </React.Fragment>
    );

    const endContent = (
        <React.Fragment>
            <Button
                label="Ajouter"
                icon="pi pi-check"
                severity="success"
                onClick={
                    () => navigate(getPathByName('configCreateUser'))
                }>
            </Button>
        </React.Fragment>
    );

    const actionBtns = (item) => {
        return (
            <React.Fragment>
                <span className="p-buttonset">
                    <Button
                        icon="pi pi-pencil"
                        onClick={() => navigate(getPathByName('configEditUser', { userId: item.id }))}
                        text raised
                    ></Button>
                    <Button
                        icon="pi pi-trash"
                        onClick={(event) => confirmRemoveUser(event, item)}
                        severity="danger"
                        text raised
                    ></Button>
                </span>
            </React.Fragment>
        );
    };

    const confirmRemoveUser = (event, user) => {

        const accept = () => {
            AppContext.api.deleteRecords("users", [user.id]).then((res) => {
                loadUsers()
            });
        };

        confirmPopup({
            target: event.currentTarget,
            message: 'Voulez-vous supprimer cet utilisateur?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            defaultFocus: 'reject',
            accept
        });
    };

    const enabledBody = (field) => {
        return field.enabled ? <strong>Activé</strong> : <span>Désactivé</span>
    };

    const enabledRowFilterTemplate = (options) => {
        return <Dropdown
            value={options.value}
            options={[{ value: true, label: 'Activé' }, { value: false, label: 'Désactivé' }]}
            onChange={(e) =>
                options.filterApplyCallback(e.value)}
            placeholder="Statut"
            className="p-column-filter"
            showClear
            style={{ minWidth: '12rem' }} />
    };

    return (
        <React.Fragment>
            <ConfirmPopup />
            <Card
                className="flex-grow-1 shadow-none border-1 surface-border fullHeightCard noPaddingCard"
                header={
                    <Toolbar
                        start={startContent}
                        end={endContent}
                        className="shadow-none border-bottom-1 surface-border border-noround-bottom"
                    />
                }
            >
                <DataTable
                    paginator
                    rows={10}
                    rowsPerPageOptions={[10, 25, 50]}
                    value={users}
                    tableStyle={{ minWidth: "50rem" }}
                    scrollable
                    scrollHeight="flex"
                    className="fullHeightTable"
                    sortMode="multiple"
                    removableSort 
                    globalFilterFields={['name', 'code', 'contact_email']}
                    filters={filters}
                >
                    <Column field="name" header="Nom" filter sortable></Column>
                    <Column field="email" header="Email" filter sortable></Column>
                    <Column field="enabled" header="Statut" body={enabledBody}
                        dataType="boolean"
                        filter
                        filterElement={enabledRowFilterTemplate}
                        sortable></Column>
                    <Column header="" body={actionBtns} style={{ width: '85px' }}></Column>
                </DataTable>
            </Card>
        </React.Fragment>
    );
}

export default Users;
